/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import DrillAnswerResultVo from './DrillAnswerResultVo';




  /**
   * The DrillSectionVo model module.
   * @module drill/model/DrillSectionVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>DrillSectionVo</code>.
   * @alias module:drill/model/DrillSectionVo
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>DrillSectionVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/DrillSectionVo} obj Optional instance to populate.
   * @return {module:drill/model/DrillSectionVo} The populated <code>DrillSectionVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'drillType')) {
        obj['drillType'] = ApiClient.convertToType(data['drillType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'items')) {
        obj['items'] = ApiClient.convertToType(data['items'], [DrillAnswerResultVo]);
      }
    }
    return obj;
  }

  /**
   * 题型 CHOICE_QUESTION_DRILL(1：单项选择题 )；COMPLETION_DRILL(2： 选词、句填空)；DIALOGUE_DRILL(3： 对话题)；LISTENING_CHOICE_DRILL(4： 听录音选择)；MATCH_DRILL(5： 匹配题)；NOTE_DRILL(6： note)；ORAL_READING_DRILL(7： 口头朗读题)；READBACK_DRILL(8： 听录音复诵)；READING_CHOICE_DRILL(9： 阅读多项选择题)；READING_DRILL(10： 纯阅读题)；SUBSTITUTION_DRILL(11： 替换题)；TRANSLATION_DRILL(12： 翻译题)；WORD_PHRASE_DRILL(13： 单词卡片题)；CLOZE_DRILL(14： 完形填空)；SEQUENCING_DRILL(15： 组词成句题)；LISTENING_ESSAY_DRILL(16： 听录音简答题)；READING_ESSAY_DRILL(17： 阅读题简答题)；
   * @member {Integer} drillType
   */
  exports.prototype['drillType'] = undefined;
  /**
   * 题目列表
   * @member {Array.<module:drill/model/DrillAnswerResultVo>} items
   */
  exports.prototype['items'] = undefined;



  export default exports;
;


